<template>
  <div class="text-center"></div>
</template>

<script>
  import gql from 'graphql-tag';
  export default {
    methods: {
      getCategorias(vue) {
        if (!vue) return;
        let sql = gql`
          query {
            getCategorias {
              id
              nombre
              descripcion
              estado
              unidad_negocio_id
            }
          }
        `;
        vue.$apollo
          .query({
            query: sql,
          })
          .then(({ data: { getCategorias } }) => {
            let data = getCategorias.filter((x) => {
              return x.id <= 3;
            });
            data.map((x) => {
              x.text = x.nombre;
            });
            vue.categorias = data;
          })
          .catch(() => []);
      },
      getDepartamentos(vue) {
        if (!vue) return;
        let sql = gql`
          query {
            getDepartamentos {
              id
              nombre
              extension
            }
          }
        `;
        vue.$apollo
          .query({
            query: sql,
          })
          .then(({ data: { getDepartamentos } }) => {
            getDepartamentos.map((x) => {
              x.text = x.nombre;
            });
            vue.departamentos = getDepartamentos;
          })
          .catch(() => []);
      },

      getSedes(vue) {
        if (!vue) return;
        let sql = gql`
          query {
            getSedes {
              id
              nombre
            }
          }
        `;
        vue.$apollo
          .query({
            query: sql,
          })
          .then(({ data: { getSedes } }) => {
            getSedes.map((x) => {
              x.text = x.nombre;
            });
            vue.sedes = getSedes;
          })
          .catch(() => []);
      },
    },
  };
</script>
